import React from 'react';

import { ButtonEdit, Card } from './styled';
import { IoMdCreate } from 'react-icons/io';
import { useHistory } from 'react-router-dom';
export function CardCustomer({ data }) {
  const history = useHistory();

  function handleEdit() {
    const client = {
      CLI_CODIGO: data.CLI_CODIGO,
      CLI_NOME_FANTASIA: data.CLI_NOME_FANTASIA,
      CLI_RAZAO_SOCIAL: `${data.CLI_CODIGO} - ${data.CLI_RAZAO_SOCIAL}`,
      GPC_CLI_ID: data.GPC_CLI_ID,
    };

    const searchs = data.PESQUISAS.map(item => {
      item.GAP_FLG_ESPECIFICA_LABEL = 2
      if (item.GPC_FLG_STATUS) {
        item.GAP_FLG_ESPECIFICA_LABEL = 1
      }
      return item
    })

    history.push({
      pathname: '/AddSearchsNotApplied',
      state: {
        client,
        searchs
      },
    });
  }

  return (
    <Card>
      <div>
        <span>Cliente</span>
        <span className="descriptionSpan">
          {data.CLI_CODIGO} - {data.CLI_NOME_FANTASIA}
        </span>
      </div>
      <div>
        <span>Razão social</span>
        <span className="descriptionSpan">{data.CLI_RAZAO_SOCIAL}</span>
      </div>

      {data?.PESQUISAS?.some((e) => e.STATUS === 'EXCLUSAO') && (
        <div className="cardSearch">
          <span style={{ fontWeight: '700', color: '#8e44ad', margin: '0.5rem 0rem' }}>PESQUISAS NÃO APLICADAS</span>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
            {data?.PESQUISAS?.filter((e) => e.STATUS === 'EXCLUSAO').map((item) => (
              <div
                key={item.GAP_ID}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  borderBottom: '1px solid #ebebeb',
                  paddingBottom: '0.2rem',
                }}
              >
                {item.GAP_ICONE && (
                  <img src={item.GAP_ICONE} style={{ width: '22px', height: '22px' }} alt={item.GAP_DESCRICAO} />
                )}
                <span>{`${item.GAP_DESCRICAO.toUpperCase()}`}</span>
                <span style={{ fontSize: '0.8rem', fontWeight: '500' }}>
                  ({`${item.GAP_DESCRICAO_LONGA.toUpperCase()}`})
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      {data?.PESQUISAS?.some((e) => e.STATUS === 'INCLUSAO') && (
        <div className="cardSearch">
          <span style={{ fontWeight: '700', color: '#8e44ad', margin: '0.5rem 0rem' }}>PESQUISAS INCLUSAS</span>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
            {data?.PESQUISAS?.filter((e) => e.STATUS === "INCLUSAO").map((item) => (
              <div
                key={item.GAP_ID}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  borderBottom: '1px solid #ebebeb',
                  paddingBottom: '0.2rem',
                }}
              >
                {item.GAP_ICONE && (
                  <img src={item.GAP_ICONE} style={{ width: '22px', height: '22px' }} alt={item.GAP_DESCRICAO} />
                )}
                <span>{`${item.GAP_DESCRICAO.toUpperCase()}`}</span>
                <span style={{ fontSize: '0.8rem', fontWeight: '500' }}>
                  ({`${item.GAP_DESCRICAO_LONGA.toUpperCase()}`})
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div>
        <ButtonEdit onClick={handleEdit}>
          <IoMdCreate size={18} />
          Editar
        </ButtonEdit>
      </div>
    </Card>
  );
}
